import { SingleValueEditorProps } from 'scopeData/editors/types';
import { ComponentShapeSelect } from '@ardoq/select';

const ShapeSelector = ({
  label,
  value,
  onValueChange,
  isDisabled,
  disabledMessage,
  description,
  dataClickId,
  placeholder,
  i18nLocale,
  preventBodyScroll,
}: SingleValueEditorProps) => {
  return (
    <ComponentShapeSelect
      preventBodyScroll={preventBodyScroll}
      label={label}
      value={value as string}
      onValueChange={onValueChange}
      isDisabled={isDisabled}
      helperText={isDisabled ? disabledMessage : description}
      clickId={dataClickId}
      placeholder={placeholder}
      isClearable
      i18nLocale={i18nLocale}
    />
  );
};

export { ShapeSelector };
